import React from 'react';
import styles from './DetailSheet.module.scss';

export const DetailSheet: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={styles.root}>{children}</div>
);

export const DetailSheetHead: React.FC<{
  title: React.ReactNode;
  tags?: React.ReactNode;
}> = ({ title, tags }) => (
  <div className={styles.head}>
    <div className={styles.title}>{title}</div>
    {tags && <div className={styles.tags}>{tags}</div>}
  </div>
);

export const DetailSheetSection: React.FC<{
  label: string;
  children: React.ReactNode;
}> = ({ label, children }) => (
  <div className={styles.section}>
    <div className={styles.fieldLabel}>{label}</div>
    {children}
  </div>
);

export const DetailSheetRow: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={styles.row}>{children}</div>
);

export const DetailSheetCol: React.FC<{ label: string; value: React.ReactNode }> = ({
  label,
  value,
}) => (
  <div className={styles.rowCol}>
    <div className={styles.fieldLabel}>{label}</div>
    <div className={styles.value}>{value}</div>
  </div>
);

export const DetailSheetChips: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={styles.chips}>{children}</div>
);

export const DetailSheetText: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={styles.text}>{children}</div>
);

export const DetailSheetValue: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={styles.value}>{children}</div>
);

export const DetailSheetEmpty: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={styles.valueFaint}>{children}</div>
);

export const DetailSheetLink: React.FC<{ name: string; onClick: () => void }> = ({
  name,
  onClick,
}) => (
  <button type="button" className={styles.link} onClick={onClick}>
    <span className={styles.linkDot} />
    <span className={styles.linkName}>{name}</span>
  </button>
);

export interface DetailSheetActionItem {
  key: string;
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
  danger?: boolean;
  disabled?: boolean;
}

export const DetailSheetActions: React.FC<{ items: DetailSheetActionItem[] }> = ({ items }) => (
  <div className={styles.actions}>
    {items.map((item) => (
      <button
        key={item.key}
        type="button"
        className={item.danger ? `${styles.action} ${styles.actionDanger}` : styles.action}
        onClick={item.onClick}
        disabled={item.disabled}
      >
        {item.icon && <span className={styles.actionIcon}>{item.icon}</span>}
        {item.label}
      </button>
    ))}
  </div>
);
